import React, { useEffect, useState } from 'react'
import { Table } from '../../components/Table/Table'
import { left_arrow, no_image, view_icon } from '../../assets/imgs';
import { useLocation, useNavigate } from 'react-router-dom';
import { admin_list } from '../redux/api/dummyJson';
import CancelIcon from '@mui/icons-material/Cancel';
import { useLazyUsersListViewQuery, useUserBookingDetailsMutation, useUserListEditMutation } from '../redux/api/api';
import { toast } from 'react-toastify';
import moment from 'moment';
import DatePicker from 'react-datepicker';

const UsersView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [popup, setPopup] = useState(false);
    const [loader, setLoader] = useState(false);
    const [type, setType] = useState("");
    const [name, setName] = useState("");
    const [list, setList] = useState([]);
    const [email, setEmail] = useState("");
    const [mobile, setMobile] = useState("");
    const [marital, setMarital] = useState("");
    const [secMobile, setSecMobile] = useState("");
    const [gender, setGender] = useState("");
    const [address, setAddress] = useState("");
    const [count, setCount] = useState();
    const [profileImage, setProfileImage] = useState("");
    const [deactive, setDeactivate] = useState("");
    const [fromdate, setFromDate] = useState('')
    const [toDate, setToDate] = useState('')
    const [pageno, setPageno] = useState(1);
    const [pagecount, setPagecount] = useState("");

    const id = location?.state?.id;
    console.log("id", id);
    console.log("frmmm", fromdate);
    const types = location?.state?.type;

    console.log('gender', gender);
    


    const [userListViewApi] = useLazyUsersListViewQuery();
    const [userListEditApi] = useUserListEditMutation();
    const [bookingListApi] = useUserBookingDetailsMutation();

    const [active, setActive] = useState('Profile');


    const usersListView = (id) => {
        userListViewApi(id)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.data?.name) {
                    setName(res?.data?.name);
                }
                if (res?.data?.email) {
                    setEmail(res?.data?.email);
                }
                if (res?.data?.mobile) {
                    setMobile(res?.data?.mobile);
                }
                if (res?.data?.marital_status) {
                    setMarital(res?.data?.marital_status);
                }
                if (res?.data?.gender) {
                    console.log('res?.data?.gender', res?.data?.gender);
                    
                    setGender(res?.data?.gender);
                }
                if (res?.data?.secondary_number) {
                    setSecMobile(res?.data?.secondary_number);
                }
                if (res?.data?.address) {
                    setAddress(res?.data?.address);
                }
                if (res?.data?.total_bookings) {
                    setCount(res?.data?.total_bookings);
                }
                setProfileImage(res?.data?.image ? res?.data?.image : no_image);
                if (res?.data?.deactivated_at) {
                    setDeactivate(res?.data?.deactivated_at);
                }
            })
            .catch((err) => {
                console.log("err", err);
            })
    }
    const usersListEdit = (id) => {
        const regEx = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!name) {
            toast.error("Enter Name");
            return;
        }
        if (!email || !regEx.test(email)) {
            toast.error("Enter Valid Email");
            return;
        }
        const formdata = new FormData();
        formdata.append("name", name);
        formdata.append("email", email);
        formdata.append("mobile", mobile);
        formdata.append("marital_status", marital);
        if (secMobile) {
            formdata.append("secondary_number", secMobile);
        }
        formdata.append("gender", gender);

        formdata.append("address", address);
        setLoader(true);
        userListEditApi({ payload: formdata, id: id })
            .unwrap()
            .then((res) => {
                console.log("res", res);
                if (res?.status == "success") {
                    toast.success(res?.message);
                    setLoader(false)
                    navigate(-1);
                    setName("");
                    setEmail("");
                    setMobile("");
                    setMarital("");
                    setGender("");
                    setSecMobile("");
                    setCount("");
                }

            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }
    const usersBookingList = (fromdate, toDate, pageno) => {
        const formdata = new FormData();
        if (fromdate && toDate) {
            formdata.append("from_date", moment(fromdate).format('YYYY-MM-DD'));
            formdata.append("to_date", moment(toDate).format('YYYY-MM-DD'));
        }

        formdata.append("user_id", id);
        formdata.append("page", pageno);
        formdata.append("row", 10);
        setLoader(true);
        setFromDate(fromdate)
        setToDate(toDate)
        bookingListApi(formdata)
            .unwrap()
            .then((res) => {
                console.log("res", res);
                let temp = []
                res?.data?.map((item, ind) => {
                    let obj = { ...item }
                    obj.current_page = res?.pagination?.current_page
                    temp.push(obj)
                })
                setList(temp);
                setPagecount(res?.pagination);

            })
            .catch((err) => {
                console.log("err", err);
            }).finally(() => {
                setLoader(false);
            })
    }

    useEffect(() => {
        if (id) {
            usersListView(id);
            usersBookingList(fromdate, toDate, pageno);
        }
    }, [pageno]);

    const columns = React.useMemo(
        () => [
            {
                Header: "S.No",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row.index + 1}</p>;
                },
            },
            {
                Header: "Booking ID",
                accessor: "booking_id",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Property Name",
                accessor: "property",
                Cell: ({ value, row }) => {
                    return <p>{value?.name}</p>;
                },
            },
            {
                Header: "Owner name",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row?.original?.property?.owner?.name}</p>;
                },
            },
            {
                Header: "City",
                accessor: "",
                Cell: ({ value, row }) => {
                    return <p>{row?.original?.property?.city}</p>;
                },
            },
            {
                Header: "Price",
                accessor: "total_amount",
                Cell: ({ value, row }) => {
                    return <p>{value}</p>;
                },
            },
            {
                Header: "Date & Time",
                accessor: "from_date",
                Cell: ({ value, row }) => {
                    return <p>{moment(value).format('DD-MM-YYYY')}</p>;
                    // return <p>{moment(value).format('DD-MM-YYYY, h:mm:ss a')}</p>;
                },
            },
            {
                Header: "Status",
                accessor: "status",
                Cell: ({ value, row }) => {
                    return (<button className="cust-btn susp-btn" >
                        <p className="mb-0">{value == 1 ? "Upcoming" : value == 2 ? "Check In" : value == 3 ? "Checked Out" : "Cancelled"}</p>
                    </button>)
                },
            },
            {
                Header: "Action",
                accessor: "",
                Cell: ({ value, row }) => {
                    return (
                        <React.Fragment>
                            <div className="d-flex ac-jc">

                                <button
                                    onClick={() => { setPopup(true); setType("add") }}
                                    className="cust-btn "
                                >
                                    <img src={view_icon} alt="" className="mx-2 edit-btn " />
                                </button>
                            </div>
                        </React.Fragment>
                    );
                },
            },
        ],
        []
    );


    return (
        <div className="dashRightView home_section" >
            <div className='d-flex ac-jb'>
                <h2 className="f3 fs-sm-12 fs-md-16 fs-lg-18 fs-xl-20 fs-xxl-22 sec">
                    User {types == "edit" ? "Edit" : "view"}
                </h2>
                <div onClick={() => { setPopup(true) }} className='d-flex gap-2'>
                    <img src={profileImage} onChange={(e) => setProfileImage(e.target.value)} className="profile-img " />
                </div>
            </div>
            {popup && (
                <div className="img-popup-design">
                    <div className="img-popup">
                        <div className="d-flex ac-je pointer" onClick={() => setPopup(false)}>
                            <CancelIcon />
                        </div>
                        <div className='profile-img-pop' >
                            <img style={{ width: "300px", height: "300px" }}
                                src={profileImage}
                                alt=""
                                className="w-100 mt-3"
                            />
                        </div>
                    </div>
                </div>
            )}

            <div className='d-flex ac-js gap-3' style={{ cursor: 'pointer' }}>
                <div
                    className={`${active === 'Profile' ? 'line-btm' : ''}`} // Apply 'line-btm' only if active
                    onClick={() => setActive('Profile')}
                >
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">Profile</p>
                </div>
                <div
                    className={`${active === 'Booking' ? 'line-btm' : ''}`} // Apply 'line-btm' only if active
                    onClick={() => setActive('Booking')}
                >
                    <p className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-18 fs-xxl-20 mt-2 mb-0">Booking</p>
                </div>
            </div>
            <div className='d-flex ac-js gap-2 mt-3'
                onClick={() => navigate(-1)}
            >
                <img src={left_arrow} className='leftArrow mb-3' />
                <p className="f2 fs-sm-10 fs-md-16 fs-lg-16 fs-xl-18 fs-xxl-20 primary">Back</p>
            </div>

            {active == "Booking" ? (
                <div>
                    <div className='d-flex ac-js gap-2'>
                        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">From Date</label>
                        <div className='w-15'>
                            <DatePicker
                                type="date"
                                dateFormat="dd-MM-yyyy"
                                className="input-pop-new ps-2 w-100"
                                placeholderText="From Date"
                                selected={fromdate}
                                onChange={(e) => {
                                    usersBookingList(
                                        e,
                                        toDate,
                                        1,
                                    )
                                }}
                            />
                        </div>
                        <label className="f2 fs-sm-10 fs-md-10 fs-lg-12 fs-xl-14 fs-xxl-16 primary">To Date</label>
                        <div className='w-15'>
                            <DatePicker
                                type="date"
                                dateFormat="dd-MM-yyyy"
                                className="input-pop-new ps-2 w-100"
                                placeholderText="To Date"
                                selected={toDate}
                                onChange={(e) => usersBookingList(
                                    fromdate,
                                    e,
                                    1,
                                )}
                            />
                        </div>
                    </div>
                    <Table columns={columns} data={list} setPageno={setPageno} pagecount={pagecount} show={true} />
                </div>
            ) :

                <div className="">
                    <div className='d-flex gap-5 mb-3'>
                        <div className='col-md-5 '>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                User Name *
                            </h4>
                            <input type="text" readOnly={types == "view" ? true : false} value={name} onChange={(e) => setName(e.target.value)} className="input-pop ps-2 w-100" placeholder="User Name" />
                        </div>
                        <div className='col-md-5 '>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Email *
                            </h4>
                            <input type="email" readOnly={types == "view" ? true : false} value={email} onChange={(e) => setEmail(e.target.value)} className="input-pop ps-2 w-100" placeholder=" Email Address" />
                        </div>
                    </div>
                    <div className='d-flex gap-5 mb-3'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Mobile Number *
                            </h4>
                            <input type="number" readOnly value={mobile} onChange={(e) => setMobile(e.target.value)} onInput={(e) => e.target.value = e.target.value.slice(0, 10)} className="input-pop ps-2 w-100" placeholder="Mobile Number" />
                        </div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Martial Status
                            </h4>
                            {types != "view" && (
                                <select disabled={types == "view" ? true : false} value={marital} onChange={(e) => setMarital(e.target.value)} className='input-pop ps-2 w-100'>
                                    <option value={""}>Select Martial Status</option>
                                    <option value={1}>Single</option>
                                    <option value={2}>Married</option>
                                </select>
                            )}
                            {types == "view" && (
                                <input type="text" readOnly={types == "view" ? true : false} value={marital == 1 ? "Single" : marital == 2 ? "Married" : "Not Mentioned"} onChange={(e) => setMarital(e.target.value)} className="input-pop ps-2 w-100" placeholder="Martial Status" />
                            )}
                        </div>
                    </div>
                    <div className='d-flex gap-5 mb-3'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Secondary Mobile Number
                            </h4>
                            <input type="number" readOnly={types == "view" ? true : false} value={secMobile} onChange={(e) => setSecMobile(e.target.value)} onInput={(e) => e.target.value = e.target.value.slice(0, 10)} className="input-pop ps-2 w-100" placeholder="Secondary Mobile Number" />
                        </div>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Gender
                            </h4>
                            {types != "view" && (
                                <select disabled={types == "view" ? true : false} value={gender} onChange={(e) => setGender(e.target.value)} className='input-pop ps-2 w-100'>
                                    <option value={""}>Select Gender</option>
                                    <option value={1}>Male</option>
                                    <option value={2}>Female</option>
                                </select>
                            )}
                            {types == "view" && (
                                <input type="text" readOnly={types == "view" ? true : false} value={gender == 1 ? "Male" : gender == 2 ? "Female" : "Not Mentioned"} onChange={(e) => setGender(e.target.value)} className="input-pop ps-2 w-100" placeholder="Gender" />
                            )}
                        </div>
                    </div>
                    <div className='d-flex gap-5 mb-3'>
                        <div className='col-md-5'>
                            <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                Address *
                            </h4>
                            <textarea type="text" readOnly={types == "view" ? true : false} value={address} onChange={(e) => setAddress(e.target.value)} className="input-pop ps-2 w-100 h-100" placeholder="Address" />
                        </div>
                        {/* {types == "view" && (
                            <div className='col-md-5'>
                                <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                    Total Booking Count
                                </h4>
                                <input type="email" readOnly={types == "view" ? true : false} value={count} onChange={(e) => setCount(e.target.value)} className="input-pop ps-2 w-100" placeholder="Total Booking Count" />
                            </div>
                        )} */}

                    </div>
                    {types == "view" && (
                        <div className='d-flex gap-5 mt-5'>
                            {deactive != null && (
                                <div className='col-md-5'>
                                    <h4 className="f2 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mt-3 primary1">
                                        Deactivated At
                                    </h4>
                                    <input type="email" readOnly value={moment(deactive).format("DD-MM-YYYY, hh:mm:ss a")} className="input-pop ps-2 w-100" placeholder="Total Booking Count" />
                                </div>
                            )}
                        </div>
                    )}
                    {types == "edit" && (
                        <div className="d-flex ac-je mt-3">
                            <button onClick={() => { usersListEdit(id) }} className="login-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14 mt-3 "  >
                                {loader && (
                                    <div
                                        class="spinner-border spinner-border-sm "
                                        role="status"
                                        style={{ marginRight: "5px" }}
                                    ></div>
                                )}
                                Submit
                            </button>
                        </div>
                    )}
                </div>
            }
        </div>
    )
}

export default UsersView